import { CalcRect } from "../dto";

// 区域a是否包含区域b
export function isContained(a: CalcRect, b: CalcRect) {
  return (
    a.minRow <= b.minRow &&
    a.minCol <= b.minCol &&
    a.maxRow >= b.maxRow &&
    a.maxCol >= b.maxCol
  );
}

// 区域a是否与区域b相交
export function isIntersected(a: CalcRect, b: CalcRect) {
  return !(
    a.maxRow < b.minRow ||
    a.minRow > b.maxRow ||
    a.maxCol < b.minCol ||
    a.minCol > b.maxCol
  );
}
